export default {
  "component.finish": "完成",
  "component.previous": "上一步",
  "component.next": "下一步",
  "component.operations": "操作",
  "component.edit": "编辑",
};
